module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("btpBk"))).then(() => parcelRequire('hEqeo'));